import _ from 'lodash';
import { sortOptions } from 'pages/FormProcess/helper';

export const boxColors = ['#928CDA', '#51BFE1', '#FB913A'];

export const rolePillColors = [
  'rgba(146, 140, 218, 0.6)',
  'rgba(70, 115, 209, 0.6)',
  'rgba(81, 191, 225, 0.6)',
  'rgba(251, 145, 58, 0.6)',
  'rgba(255, 87, 109, 0.6)',
  'rgba(0, 177, 82, 0.6)',
  'rgba(146, 140, 218, 0.6)',
];

export const rollPillRGBs = [
  '146, 140, 218',
  '70, 115, 209',
  '81, 191, 225',
  '251, 145, 58',
  '255, 87, 109',
  '0, 177, 82',
  '146, 140, 218',
];

export const getBoxBorderStyle = (index) => ({
  borderLeft: `3px solid ${boxColors[index % boxColors.length]}`,
});

export const getRolePillColor = (roleIndex) => rolePillColors[roleIndex % rolePillColors.length];
export const getRolePillRGBs = (roleIndex) => rollPillRGBs[roleIndex % rolePillColors.length];

export const getRolePillStyle = (role, smartFormRoles) => {
  const roleIndex = smartFormRoles.findIndex(({ Id }) => Id === role.Id);
  return {
    border: `1px solid ${getRolePillColor(roleIndex)}`,
    color: getRolePillColor(roleIndex),
    colorRGB: getRolePillRGBs(roleIndex),
  };
};

export const getRolePillBoxStyle = (role, smartFormRoles) => {
  const roleIndex = smartFormRoles.findIndex(({ Id }) => Id === role.Id);
  return { borderLeft: `3px solid ${getRolePillColor(roleIndex)}` };
};

export const isMultipleDocuments = (locationState) => {
  return Boolean(
    locationState?.documentLink &&
      Array.isArray(locationState?.documentLink) &&
      locationState?.documentLink.length > 1,
  );
};

export const getLibraryRoles = (formRoles, savedSignatories) => {
  const filteredRoles = formRoles.filter(({ Id }) => !savedSignatories?.[Id]);

  return sortOptions(filteredRoles, 'Name');
};

export const getRoleName = (roleId: number | undefined, saveAsTemplate, allRoles) => {
  if (roleId && saveAsTemplate) {
    return allRoles.find((role) => role.key === roleId)?.label;
  }
};

export const getRoleOptions = (allRoles, templateFormRoles) => {
  let roles = templateFormRoles?.length
    ? allRoles.filter(({ key }) => !templateFormRoles.includes(key))
    : allRoles;

  return roles;
  // return sortOptions(roles, 'label');
};

export const getExistingRoleIds = (savedRoles, savedSignatories = {}) => {
  if (!_.isEmpty(savedSignatories)) {
    return Object.values(savedSignatories).map((item: any) => item.FormRoleId);
  } else if (savedRoles) {
    return savedRoles;
  }

  return [];
};

export const isSaveAsTemplateDisable = (templateFormRoles, signatories) => {
  const allFilledRoles = templateFormRoles?.filter((item) => item);
  return !allFilledRoles.length || allFilledRoles.length < signatories.length;
};

export const isTemplateDisable = (signatories) => {
  const hasSignatory = signatories.find((item) => !item.customName && (item.Name || item.Email));

  const hasCustomName = signatories.find((item) => item.customName);

  const hasFilledCustomSignatory = signatories.find((item) => item.customName && item.Name);

  return (
    !(hasSignatory || (hasCustomName && hasFilledCustomSignatory)) ||
    (hasSignatory && hasCustomName && !hasFilledCustomSignatory)
  );
};

export const isBundleDisable = (signatories) => {
  return !signatories.find((item) => item.Name && item.Email);
};
